import { useEffect, useState, useCallback } from "react";
import * as signalR from "@microsoft/signalr";
import { getWorkchestraOrigin } from "@/lib/utils";

export const useJobOrderEddNotifications = (jobOrderId: number | null) => {
  const [connection, setConnection] = useState<signalR.HubConnection | null>(
    null
  );
  const [jobOrderUpdates, setJobOrderUpdates] = useState<any>(null);
  const [isConnected, setIsConnected] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  // Initialize connection
  useEffect(() => {
    const newConnection = new signalR.HubConnectionBuilder()
      .withUrl(getWorkchestraOrigin() + "/eddnotificationhub")
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);

    return () => {
      if (newConnection) {
        newConnection.stop();
      }
    };
  }, []);

  // Start connection
  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          console.log("Connected to EDD notification hub");
          setIsConnected(true);

          // Listen for job order specific updates
          connection.on("JobOrderEddUpdate", (data) => {
            console.log("Job Order EDD Update received:", data);
            setJobOrderUpdates(data);
          });

          connection.on("SubscriptionConfirmed", (data) => {
            console.log("Subscribed to Job Order:", data);
            setIsSubscribed(true);
          });

          connection.on("UnsubscriptionConfirmed", (data) => {
            console.log("Unsubscribed from Job Order:", data);
            setIsSubscribed(false);
          });
        })
        .catch((error) => {
          console.error("Connection failed:", error);
          setIsConnected(false);
        });
    }
  }, [connection]);

  useEffect(() => {
    if (connection && isConnected && jobOrderId) {
      connection
        .invoke("SubscribeToJobOrder", jobOrderId)
        .catch((err) =>
          console.error("Failed to subscribe to job order:", err)
        );

      return () => {
        // Cleanup subscription when component unmounts or jobOrderId changes
        if (
          connection &&
          connection.state === signalR.HubConnectionState.Connected
        ) {
          connection
            .invoke("UnsubscribeFromJobOrder", jobOrderId)
            .catch((err) =>
              console.error("Failed to unsubscribe from job order:", err)
            );
        }
      };
    }
  }, [connection, isConnected, jobOrderId]);

  const clearUpdates = useCallback(() => {
    setJobOrderUpdates(null);
  }, []);

  return {
    jobOrderUpdates,
    isConnected,
    isSubscribed,
    clearUpdates,
  };
};
